/**
 * @overview 素材相关全局数据
 *
 * @author huojinzhao
 */

import { $http } from "@/utils";

export default {
  namespaced: true,

  state: {
    types: [],
  },

  actions: {
    initTypes({ commit }) {
      return $http.get("/resource/second_version/get_types")
        .then(({ courseware_resource_types }) => {
          const obj = {};
          let count = 0;
          courseware_resource_types.map((v) => {
            obj[count] = {
              name: v.name,
              value: v.type_id,
              parent_value: v.parent_type_id,
            };
            count += 1;
            if (v.leaf) {
              v.leaf.map((q) => {
                obj[count] = {
                  name: q.name,
                  value: q.type_id,
                  parent_value: q.parent_type_id,
                };
                count += 1;
              });
            }
          });
          commit("initTypes", obj);

          return obj;
        });
    },
  },

  mutations: {
    initTypes(state, types) {
      state.types = types;
    },
  },
};
